import {
  fetchSimInfo,
  fetchPostpaidInfo,
  fetchPlanInfo,
  fetchBillCycle,
  fetchMonthlyData,
  reserveApi,
  fetchContentData,
  getPlanCategory,
  getOrderStatusApi,
  addressByZipCode,
  getPreferLanguages,
  getSourceTypes,
  getBillCycles,
  simpleActivationPost,
  sendLink,
  paymentStatus,
} from "@/http/customer/customerActivation";
import moment from "moment";
const customerEmpty = {
  clientData: [
    {
      activationDate: "30 January 2025",
      entryType: "IND",
      officeId: 7,
      clientCategory: 1,
      title: "",
      firstname: "",
      lastname: "",
      phone: "",
      email: "",
      vipId: -1,
      disabilityId: -1,
      locale: "en",
      active: true,
      dateFormat: "yyyy-MM-dd HH:mm:ss",
      district: "",
      flag: false,
      address: [
        {
          addressNo: "",
          city: "",
          state: "",
          country: "",
          district: "",
          zipCode: "",
          addressType: "PRIMARY",
        },
        {
          addressNo: "",
          city: "",
          state: "",
          country: "",
          district: "",
          zipCode: "",
          addressType: "BILLING",
        },
      ],
      idKey: 1,
      idValue: "0987653789708",
      gender: 1,
      dateOfBirth: "03 January 1900",
      nationalityId: 103,
      paymentInfo: [
        {
          RegisteredpaymentMehtods: {
            tokenID: "",
            paymentMethod: "CARD",
            last4Digits: "1234",
            expiryDate: "",
            cardType: "VISA",
          },
          paymentTransaction: {
            paymentOrderID: "1",
            paymentOrderStatus: "Active",
          },
          billProfile: {
            invoiceType: "Summary",
            billSuppressionFlag: "N",
            fiscalYear: "576",
            type: "",
            fiscalQuarter: "574",
            billMode: "E-invoice",
            billCycleId: "2",
          },
        },
      ],
      clientServiceData: [
        {
          clientServiceDetails: [
            {
              status: "new",
              parameterId: 688,
              parameterValue: 1,
            },
          ],
          serviceId: 1,
          type: "",
          salesMotion: "POS", //For CRM or Retailer - POS  & for digital web/mobile app - Online
          otherSalesVariables: "othersalesvariables",
          spendCap: "10",
          serviceContact: {
            firstname: "vikramYu",
            lastname: "reddyYu",
            phone: "7896777402",
            email: "vikrammech16yu@gmail.com",
          },
          shippingAddress: {
            addressNo: "",
            city: "",
            state: "",
            country: "",
            district: "",
            zipCode: "",
            addressType: "SHIPPING",
          },
          deviceData: [
            {
              locale: "en",
              dateFormat: "yyyy-MM-dd HH:mm:ss",
              officeId: 7,
              itemId: 1,
              chargeCode: "OTC",
              unitPrice: 0,
              quantity: "1",
              discountId: 1,
              totalPrice: 0,
              saleType: "NEWSALE",
              saleDate: "30 January 2025",
              serialNumber: [
                {
                  serialNumber: "",
                  status: "allocated",
                  saleType: "NEWSALE",
                  itemMasterId: 1,
                  isNewHw: "Y",
                  itemType: "IMSI",
                },
              ],
              isPairing: "Y",
              pairableItemDetails: {
                locale: "en",
                dateFormat: "yyyy-MM-dd HH:mm:ss",
                officeId: 7,
                itemId: 2,
                chargeCode: "OTC",
                unitPrice: 0,
                quantity: "1",
                discountId: 1,
                totalPrice: 0,
                saleType: "NEWSALE",
                saleDate: "30 January 2025",
                serialNumber: [
                  {
                    serialNumber: "9925833803",
                    status: "allocated",
                    saleType: "NEWSALE",
                    itemMasterId: 2,
                    isNewHw: "Y",
                    itemType: "MSISDN",
                  },
                ],
                isPairing: "N",
              },
            },
          ],
          planData: [
            {
              planId: 37,
              billAlign: false,
              autoRenew: "N",
              contractPeriodId: 12,
              paytermCode: "1 Month",
              isNewplan: true,
              locale: "en",
              dateFormat: "yyyy-MM-dd HH:mm:ss",
              start_date: "30 January 2025",
              planCode: 41,

              discounts: [10, 12],
              selectionMatrix: {
                businessType: "TestType2",
                SalesChannel: "testChannel2",
                SalesMotion: "POS",
                PaymentType: "CARD", //Online
                Term: "Testterm",
                affiliateDetails: {
                  utm_source: "affiliate1",
                  utm_medium: "affiliate",
                  utm_campaign: "summer_sale",
                },
                OrderType: "testType",
                FlexAttribute1: "test1",
                FlexAttribute2: "test2",
                FlexAttribute3: "test3",
                FlexAttribute4: "test4",
                FlexAttribute5: "test5",
                PricePlan: {
                  listprice: "10.00",
                  sellingprice: "25.03",
                  discount: "04.88",
                  discountrate: "2",
                  discountrateId: "1",
                  discountruleId: "4",
                  revisedsellingprice: "19.65",
                  tax: "02.09",
                  taxcode: "testCode",
                  taxrate: "2",
                  netsellingprice: "22.52",
                },
              },
            },



          ],
        },
      ],
    },
  ],
}
export default {
  namespaced: true,
  state: {
    // simType: "Postpaid",
    elapsedTime: 900,
    activationStage: 0,
    isPaymentDone: false,
    addressByZipData: null,
    simData: null,
    simPostpaidData: null,
    planData: [],
    monthlyData: null,
    contentData: null,
    basketData: {
      totalPrice: 0,
    },
    categoryData: {},
    adynSessionData: {},
    paymentStatusData: {},
    preferredLanguages: [],
    sourceTypes: [],
    customerInfo: {},
    billCycles: [],
    customerActivationDraft: { ...customerEmpty },
  },
  actions: {
    async addressByZipCode({ commit }, payload) {
      const response = await addressByZipCode(payload);
      commit("SET_ADDRESS_BY_ZIP_DATA", response.data.Results);
      return response;
    },
    async resetAddressByZipCode({ commit }) {
      commit("SET_ADDRESS_BY_ZIP_DATA", null);
    },
    async fetchSimInfoAction({ commit }, payload) {
      const response = await fetchSimInfo(payload);
      commit("SET_SIM_DATA", response.data.result);
      return response;
    },
    async fetchPostpaidAction({ commit }, payload) {
      const response = await fetchPostpaidInfo(payload);
      commit("SET_SIM_POSTPAID_DATA", response.data.result);
      return response;
    },
    async fetchPlanInfoAction({ commit }, payload) {
      commit("SET_PLAN_DATA", {});
      const response = await fetchPlanInfo(payload);
      commit("SET_PLAN_DATA", response.data.pageItems);
      return response;
    },
    async fetchMonthlyDataAction({ commit }, payload) {
      const response = await fetchMonthlyData(payload);
      commit("SET_MONTHLY_DATA", response.data.pageItems);
      return response;
    },
    async fetchContentDataAction({ commit }, payload) {
      const response = await fetchContentData(payload);
      commit("SET_CONTENT_DATA", response.data);
      return response;
    },
    async getPlanCategoryAction({ commit }, payload) {
      const response = await getPlanCategory(payload);
      commit("SET_CATEGORY_DATA", response.data);
      return response;
    },
    async fetchBillCycleAction(_, payload) {
      const response = await fetchBillCycle(payload);
      return response;
    },
    async customerActivationSimInfo({ commit }, simInfo) {
      commit("CUSTOMER_ACTIVATION_SIM_INFO", simInfo);
    },
    async customerActivationCustInfo({ commit }, custInfo) {
      commit("CUSTOMER_ACTIVATION_CUST_INFO", custInfo);
    },
    async customerActivationPayInfo({ commit }, payInfo) {
      commit("CUSTOMER_ACTIVATION_PAY_INFO", payInfo);
    },
    async setPreferredLanguages({ commit }) {
      const response = await getPreferLanguages();
      commit("SET_PREFERRED_LANGUAGES", response.data);
      return response;
    },
    async setSourceTypes({ commit }) {
      const response = await getSourceTypes();
      commit("SET_SOURCE_TYPES", response.data);
      return response;
    },
    async setBillCycles({ commit }) {
      const response = await getBillCycles();
      commit("SET_BILL_CYCLES", response.data.pageItems);
      return response;
    },
    async reserveApiAction(_, payload) {
      const response = await reserveApi(payload);
      return response;
    },
    clearPaymentData({ commit }) {
      commit("CLEAR_ADDRESS");
    },
    async sendLinkAction({ commit }, payload) {
      let res = await sendLink(payload);
      commit("PAYMENT_LINK_STATUS", res.data);
    },
    async checkPaymentStatus({ commit }, id) {
      let res = await paymentStatus(id);
      commit("PAYMENT_LINK_STATUS", res.data);
    },
    async orderStatus(_, payload) {
      return await getOrderStatusApi(payload);
    },
    setBasketData({ commit }, payload) {
      commit("SET_BASKET", payload);
      return payload;
    },
    clearActivationData({ commit }) {
      commit("CLEAR_ADDRESS");
    },
    async simpleActivationAction({ commit }, payload) {
      const response = await simpleActivationPost(payload);
      commit("CLEAR_ADDRESS");
      return response;
    },
    clearCustomerInfoData({ commit }) {
      commit("CLEAR_CUSTOMER_INFO");
    },
  },
  mutations: {
    CLEAR_CUSTOMER_INFO(state) {
      state.customerInfo = {};
      state.addressByZipData = null;
    },
    SET_ADDRESS_BY_ZIP_DATA(state, payload) {
      state.addressByZipData = payload;

    },
    CLEAR_ADDRESS(state) {
      state.addressByZipData = null;
      state.paymentStatusData = {};
      state.customerActivationDraft = { ...customerEmpty }
      state.activationStage = 0;
    },
    setElapsedTime(state, time) {
      state.elapsedTime = time;
    },
    setPaymentDone(state, status) {
      state.isPaymentDone = status;
    },
    SET_SIM_DATA(state, payload) {
      state.simData = payload;
      if (state.activationStage == 0) state.activationStage = 1;
    },
    SET_BASKET(state, payload) {
      state.basketData = payload;
      if (payload.stage && payload.stage > state.activationStage) state.activationStage = payload.stage;
      if (payload.planData && payload.planData[0] && payload.planData[0].planid)
        state.customerActivationDraft.clientData[0].clientServiceData[0].planData[0].planId =
          payload.planData && payload.planData[0] && payload.planData[0].planid;
    },
    SET_PREFERRED_LANGUAGES(state, payload) {
      state.preferredLanguages = payload;
    },
    SET_SOURCE_TYPES(state, payload) {
      state.sourceTypes = payload;
    },
    SET_BILL_CYCLES(state, payload) {
      state.billCycles = payload;
    },
    SET_SIM_POSTPAID_DATA(state, payload) {
      state.elapsedTime = 900;
      state.simPostpaidData = payload;
    },
    SET_PLAN_DATA(state, payload) {
      state.planData = payload;
    },
    SET_MONTHLY_DATA(state, payload) {
      state.monthlyData = payload;
    },
    CUSTOMER_ACTIVATION_SIM_INFO(state, payload) {
      state.customerActivationDraft.clientData[0].paymentInfo[0].billProfile.type =
        payload.simType;

      state.customerActivationDraft.clientData[0].clientServiceData[0].deviceData[0].saleDate =
        payload.saleDate;
      payload.serialNumber;
      state.customerActivationDraft.clientData[0].clientServiceData[0].deviceData[0].pairableItemDetails.saleDate =
        payload.saleDate;
      payload.serialNumber;
      state.customerActivationDraft.clientData[0].clientServiceData[0].deviceData[0].serialNumber[0].serialNumber =
        payload.serialNumber;
      state.customerActivationDraft.clientData[0].clientServiceData[0].deviceData[0].pairableItemDetails.serialNumber[0].serialNumber =
        payload.phoneNumber;
    },
    CUSTOMER_ACTIVATION_CUST_INFO(state, payload) {
      state.customerInfo = payload;
      let contractPeriod = payload.contractPeriod;
      state.activationStage = 3;
      // if (payload.contractPeriod == 1) contractPeriod = 12;
      // else if (payload.contractPeriod == 24) contractPeriod = 29;
      state.customerActivationDraft.clientData[0].activationDate =
        payload.activationDate;
      state.customerActivationDraft.clientData[0].firstname = payload.firstname;
      state.customerActivationDraft.clientData[0].title = payload.title;
      state.customerActivationDraft.clientData[0].lastname = payload.lastname;
      state.customerActivationDraft.clientData[0].phone = payload.phone;
      state.customerActivationDraft.clientData[0].email = payload.email;
      state.customerActivationDraft.clientData[0].dateOfBirth = payload.dob;
      state.customerActivationDraft.clientData[0].district = payload.district;
      state.customerActivationDraft.clientData[0].address[0].addressNo =
        payload.addressNo;
      state.customerActivationDraft.clientData[0].address[0].city =
        payload.city;
      state.customerActivationDraft.clientData[0].address[0].district =
        payload.district;
      state.customerActivationDraft.clientData[0].address[0].state =
        payload.state;
      state.customerActivationDraft.clientData[0].address[0].country =
        payload.country;
      state.customerActivationDraft.clientData[0].address[0].zipCode =
        payload.zipCode;
      // state.customerActivationDraft.clientData[0].address[0].addressType =
      //   payload.addressType;
      state.customerActivationDraft.clientData[0].address[1].addressNo =
        payload.addressNo;
      state.customerActivationDraft.clientData[0].address[1].city =
        payload.city;
      state.customerActivationDraft.clientData[0].address[1].district =
        payload.district;
      state.customerActivationDraft.clientData[0].address[1].state =
        payload.state;
      state.customerActivationDraft.clientData[0].address[1].country =
        payload.country;
      state.customerActivationDraft.clientData[0].address[1].zipCode =
        payload.zipCode;
      // state.customerActivationDraft.clientData[0].address[1].addressType =
      // payload.addressType;
      state.customerActivationDraft.clientData[0].clientServiceData[0].shippingAddress.addressNo =
        payload.addressNo;
      state.customerActivationDraft.clientData[0].clientServiceData[0].shippingAddress.city =
        payload.city;
      state.customerActivationDraft.clientData[0].clientServiceData[0].shippingAddress.district =
        payload.district;
      state.customerActivationDraft.clientData[0].clientServiceData[0].shippingAddress.state =
        payload.state;
      state.customerActivationDraft.clientData[0].clientServiceData[0].shippingAddress.country =
        payload.country;
      state.customerActivationDraft.clientData[0].clientServiceData[0].shippingAddress.zipCode =
        payload.zipCode;
      // state.customerActivationDraft.clientData[0]..clientServiceData[0].shippingAddress.zipCode.addressType =
      // payload.addressType;
      state.customerActivationDraft.clientData[0].clientServiceData[0].planData[0].planCode =
        payload.planCode;
      state.customerActivationDraft.clientData[0].clientServiceData[0].planData[0].contractPeriodId =
        contractPeriod;
      //  payload.contractPeriod;
      state.customerActivationDraft.clientData[0].clientServiceData[0].planData[0].paytermCode =
        payload.paytermCode;
      state.customerActivationDraft.clientData[0].clientServiceData[0].planData[0].start_date =
        payload.activationDate;
      state.customerActivationDraft.clientData[0].clientServiceData[0].spendCap =
        payload.spendCap;
      state.customerActivationDraft.clientData[0].paymentInfo[0].billProfile.billCycleId =
        payload.billingCycle;
      if (
        state.customerActivationDraft.clientData[0].paymentInfo[0].billProfile
          .type == "Prepaid"
      )
        state.customerActivationDraft.clientData[0].paymentInfo[0].billProfile.billCycleId =
          -1;

      if (state.basketData.shippingCharge && state.customerActivationDraft.clientData[0].clientServiceData[0].planData.length < 2) {
        state.customerActivationDraft.clientData[0].clientServiceData[0].planData.push({
          "planId": state.customerActivationDraft.clientData[0].paymentInfo[0].billProfile
            .type == "Prepaid" ? 415 : 362,
          "billAlign": false,
          "autoRenew": "N",
          "contractPeriodId": 12,
          "paytermCode": "Once",
          "isNewplan": true,
          "locale": "en",
          "dateFormat": "yyyy-MM-dd HH:mm:ss",
          "start_date": moment().format("YYYY-MM-DD HH:mm:ss"),
          "planCode": state.customerActivationDraft.clientData[0].paymentInfo[0].billProfile
            .type == "Prepaid" ? 415 : 362,
          "discounts": [],
          "selectionMatrix": {
            "businessType": "TestType2",
            "SalesChannel": "testChannel2",
            "SalesMotion": "POS",
            "PaymentType": "CARD",
            "Term": "Testterm",
            "affiliateDetails": {
              "utm_source": "affiliate1",
              "utm_medium": "affiliate",
              "utm_campaign": "summer_sale"
            },
            "OrderType": "testType",
            "FlexAttribute1": "test1",
            "FlexAttribute2": "test2",
            "FlexAttribute3": "test3",
            "FlexAttribute4": "test4",
            "FlexAttribute5": "test5",
            "PricePlan": {
              "listprice": state.basketData.shippingCharge,
              "sellingprice": state.basketData.shippingCharge,
              "discount": "04.88",
              "discountrate": "2",
              "discountrateId": "1",
              "discountruleId": "4",
              "revisedsellingprice": state.basketData.shippingCharge,
              "tax": "0",
              "taxcode": "testCode",
              "taxrate": "0",
              "netsellingprice": state.basketData.shippingCharge
            }
          }
        })
      }
    },
    CUSTOMER_ACTIVATION_PAY_INFO(state, payload) {
      state.activationStage = 5;
      state.customerActivationDraft.clientData[0].paymentInfo[0].RegisteredpaymentMehtods.tokenID =
        payload.tokenID;
      state.customerActivationDraft.clientData[0].paymentInfo[0].RegisteredpaymentMehtods.paymentMethod =
        payload.paymentMethod;
      state.customerActivationDraft.clientData[0].paymentInfo[0].RegisteredpaymentMehtods.last4Digits =
        payload.last4Digits;
      state.customerActivationDraft.clientData[0].paymentInfo[0].RegisteredpaymentMehtods.expiryDate =
        payload.expiryDate;
      state.customerActivationDraft.clientData[0].paymentInfo[0].RegisteredpaymentMehtods.cardType =
        payload.cardType;
      state.customerActivationDraft.clientData[0].paymentInfo[0].paymentTransaction.paymentOrderID =
        payload.paymentOrderID;
      state.customerActivationDraft.clientData[0].paymentInfo[0].paymentTransaction.paymentOrderStatus =
        payload.paymentOrderStatus;
      state.customerActivationDraft.clientData[0].paymentInfo[0].billProfile.invoiceType =
        payload.invoiceType;
      state.customerActivationDraft.clientData[0].paymentInfo[0].billProfile.billSuppressionFlag =
        payload.billSuppressionFlag;
      state.customerActivationDraft.clientData[0].paymentInfo[0].billProfile.fiscalYear =
        payload.fiscalYear;
      state.customerActivationDraft.clientData[0].paymentInfo[0].billProfile.fiscalQuarter =
        payload.fiscalQuarter;
      state.customerActivationDraft.clientData[0].paymentInfo[0].billProfile.billMode =
        payload.billMode;
    },
    SET_CONTENT_DATA(state, payload) {
      state.contentData = payload;
    },
    SET_CATEGORY_DATA(state, payload) {
      state.categoryData = payload;
    },
    SET_SESSION_DATA(state, payload) {
      state.adynSessionData = payload;
    },
    PAYMENT_LINK_STATUS(state, payload) {
      state.paymentStatusData = payload;
    },
  },
  getters: {},
};
